import { render, staticRenderFns } from "./Organism3DModelInteraction.vue?vue&type=template&id=4dd23eec&"
import script from "./Organism3DModelInteraction.vue?vue&type=script&lang=js&"
export * from "./Organism3DModelInteraction.vue?vue&type=script&lang=js&"
import style0 from "./Organism3DModelInteraction.vue?vue&type=style&index=0&id=4dd23eec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesProjectMoleculeZoomSlider: require('/app/components/molecules/project/MoleculeZoomSlider.vue').default})
